import { Theme, Container } from '@material-ui/core';
import { createStyles, withStyles } from '@material-ui/styles';
import { equals } from 'ramda';
import { Fragment } from 'react';
import { useSelector } from 'react-redux';

import { PageLoader, PageContent, PagePagination } from '../Page';

import { Pagination } from '~models';
import { selectors } from '~store';
import { DataPlaceholder } from '~ui-kit';

export interface PaginatedRoutingLinkListProps<T> {
  data: T[];
  loading?: boolean;
  renderItem: (item: T, i: number) => unknown;
  onPaginationChange: (pagination: Pagination) => void;
}

const GridContainer = withStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
      padding: '30px 0px 0px 30px',
      height: '100%',
      width: '100%',
      listStyle: 'none',
    },
  })
)(Container);

const PaginationContainer = withStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: '0px 20px 20px 20px',
    },
  })
)(Container);

export const PaginatedRoutingLinkList = <T extends unknown>({
  data,
  loading,
  renderItem,
  onPaginationChange,
}: PaginatedRoutingLinkListProps<T>) => {
  const pagination = useSelector(selectors.page.getPagePagination, equals);

  if (loading) {
    return (
      <PageContent>
        <PageLoader />
      </PageContent>
    );
  }

  return (
    <Fragment>
      <PageContent>
        {data?.length ? <GridContainer>{data.map(renderItem)} </GridContainer> : <DataPlaceholder />}
      </PageContent>

      {pagination.totalPages > 1 ? (
        <PaginationContainer>
          <PagePagination isHideTitle={true} pagination={pagination} loading={loading} onChange={onPaginationChange} />
        </PaginationContainer>
      ) : null}
    </Fragment>
  );
};
